export default "__VITE_ASSET__a6460ff3__"